import { CodeBlock } from "@mittwald/flow-remote-react-components";
import { Link } from "@mittwald/flow-remote-react-components";
import { Text } from "@mittwald/flow-remote-react-components";
import {
  defaultErrorComponentMap,
  ErrorMap,
  getSupportEmail,
} from "@wiesinghilker/extension-lib-frontend";

const SupportEmailLink = ({ error }: { error: Error }) => {
  const supportEmail = getSupportEmail();
  return (
    <Link
      href={`mailto:${supportEmail}?subject=${encodeURIComponent("Fehler in der Extension")}&body=${encodeURIComponent(`Folgender Fehler ist bei der Benutzung der Extension aufgetreten:\n\n${error.stack ?? error.message}\n\nDer Fehler ist auf folgender Seite aufgetreten:\n\n${window.location.href}`)}`}
    >
      {supportEmail}
    </Link>
  );
};

export const errorMap: ErrorMap = {
  ...defaultErrorComponentMap,
  ChangeUserPasswordError: (error: Error) => (
    <>
      <Text>
        Wir konnten das Passwort des Benutzers nicht ändern. Folgende
        Fehlermeldung wurde vom Server geliefert:
      </Text>
      <CodeBlock code={error.message} copyable />
      <Text>
        Bitte überprüfe, ob du aus dieser Fehlermeldung das Problem ableiten
        kannst. Falls nicht, wende dich bitte an unseren Support:
      </Text>
      <SupportEmailLink error={error} />
    </>
  ),
  CreateUserError: (error: Error) => (
    <>
      <Text>
        Das Passwort des Benutzers konnte nicht erfolgreich geändert werden.
        Folgende Fehlermeldung wurde vom Server geliefert:
      </Text>
      <CodeBlock code={error.message} copyable />
      <Text>
        Bitte überprüfe, ob du aus dieser Fehlermeldung das Problem ableiten
        kannst. Falls nicht, wende dich bitte an unseren Support:
      </Text>
      <SupportEmailLink error={error} />
    </>
  ),
  DeclareDirectoryProtectionError: (error: Error) => (
    <>
      <Text>
        Der Passwortschutz konnte leider nicht angelegt werden. Folgende
        Fehlermeldung wurde vom Server geliefert:
      </Text>
      <CodeBlock code={error.message} copyable />
      <Text>
        Bitte überprüfe, ob du aus dieser Fehlermeldung das Problem ableiten
        kannst. Falls nicht, wende dich bitte an unseren Support:
      </Text>
      <SupportEmailLink error={error} />
    </>
  ),
  DeleteDirectoryProtection: (error: Error) => (
    <>
      <Text>
        Der Passwortschutz könnte leider nicht gelöscht werden. Folgende
        Fehlermeldung wurde vom Server geliefert:
      </Text>
      <CodeBlock code={error.message} copyable />
      <Text>
        Bitte überprüfe, ob du aus dieser Fehlermeldung das Problem ableiten
        kannst. Falls nicht, wende dich bitte an unseren Support:
      </Text>
      <SupportEmailLink error={error} />
    </>
  ),
  DeleteUserError: (error: Error) => (
    <>
      <Text>
        Der Benutzer konnte leider nicht gelöscht werden. Folgende Fehlermeldung
        wurde vom Server geliefert:
      </Text>
      <CodeBlock code={error.message} copyable />
      <Text>
        Bitte überprüfe, ob du aus dieser Fehlermeldung das Problem ableiten
        kannst. Falls nicht, wende dich bitte an unseren Support:
      </Text>
      <SupportEmailLink error={error} />
    </>
  ),
  ListDirectoryProtectionsError: (error: Error) => (
    <>
      <Text>
        Wir konnten die Passwortschutze deines Projektes leider nicht laden.
        Folgende Fehlermeldung wurde vom Server geliefert:
      </Text>
      <CodeBlock code={error.message} copyable />
      <Link href={window.location.href}>Nochmal versuchen</Link>
      <Text>
        Wenn sich das Problem nicht lösen lässt, wende dich bitte an unseren
        Support:
      </Text>
      <SupportEmailLink error={error} />
    </>
  ),
  ListUsersError: (error: Error) => (
    <>
      <Text>
        Wir konnten die Benutzer deiner Passwortschutze leider nicht laden.
        Folgende Fehlermeldung wurde vom Server geliefert:
      </Text>
      <CodeBlock code={error.message} copyable />
      <Link href={window.location.href}>Nochmal versuchen</Link>
      <Text>
        Wenn sich das Problem nicht lösen lässt, wende dich bitte an unseren
        Support:
      </Text>
      <SupportEmailLink error={error} />
    </>
  ),
};
